var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c(
        "div",
        { staticClass: "container container-medium mt-3 article reading" },
        [
          _c("p", [
            _vm._v(
              "Nu se pot emite roviniete cu data de valabilitate anterioara datei de emitere."
            ),
          ]),
          _c("p", [
            _vm._v(
              "Nu se pot emite roviniete decat cu cel mult 30 zile anterior datei de inceput a valabilitatii."
            ),
          ]),
          _c("p", [
            _vm._v(
              "Rovinietele se emit numai dupa confirmarea platii sumei in contul bancar al UNTRR (in cateva minute in cazul platii online cu cardul bancar finalizate sau cateva zile in cazul platii prin ordin de plata)."
            ),
          ]),
          _c("p", [
            _vm._v(
              "In conformitate cu dispozitiile art. 1 alin. 1 lit.j din OG 15/2002, aprobata de Legea 424/2002, rovinieta este definita ca fiind documentul sau inregistrarea in format electronic care atesta achitarea tarifului de utilizare a retelei de drumuri nationale din Romania. Modelul, forma, continutul, modul, conditiile si mijloacele de eliberare ale rovinietei se stabilesc prin normele metodologice aprobate prin ordin al ministrului transporturilor si infrastructurii."
            ),
          ]),
          _c("p", [
            _vm._v(
              "Tariful de utilizare este structurat in functie de durata de utilizare a retelei de drumuri nationale din Romania ( o zi, 30 de zile, 90 de zile, 12 luni). Durata de utilizare cuprinde durata de parcurs, precum si durata de stationare."
            ),
          ]),
          _c("p", [
            _vm._v(
              "Tariful de utilizare stablit prin Ordonanta 8 din 2010 este urmatorul:"
            ),
          ]),
          _c("div", { staticClass: "table-responsive" }, [
            _c(
              "table",
              { staticClass: "table table-stripped", attrs: { width: "800" } },
              [
                _c("tr", [
                  _c("th", { attrs: { width: "100" } }, [_vm._v("Categoria")]),
                  _c("th", { attrs: { width: "500" } }, [
                    _vm._v("Tipul vehiculului"),
                  ]),
                  _c("th", { attrs: { width: "200" } }, [
                    _vm._v(
                      "Durata de utilizare a retelei de drumuri nationale din Romania"
                    ),
                  ]),
                  _c("th", { attrs: { width: "200" } }, [
                    _vm._v("Tariful [EURO] (TVA inclus)"),
                  ]),
                ]),
                _c("tr", [
                  _c("th", [_vm._v("Category")]),
                  _c("th", [_vm._v("Type of vehicle")]),
                  _c("th", [
                    _vm._v("Period of use of national road network in Romania"),
                  ]),
                  _c("th", [_vm._v("Tariff [EURO] (including VAT)")]),
                ]),
                _c("tr", [
                  _c("td", { attrs: { rowspan: "5" } }, [_vm._v("A")]),
                  _c("td", { attrs: { rowspan: "5" } }, [
                    _c("p", [_vm._v("autoturism")]),
                    _c("p", [_vm._v("car")]),
                  ]),
                  _c("td", [_vm._v("-")]),
                  _c("td", [_vm._v("-")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("7 zile / days")]),
                  _c("td", [_vm._v("3")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("30 zile / days")]),
                  _c("td", [_vm._v("7")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("90 zile / days")]),
                  _c("td", [_vm._v("13")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("12 luni / months")]),
                  _c("td", [_vm._v("28")]),
                ]),
                _c("tr", [
                  _c("td", { attrs: { rowspan: "5" } }, [_vm._v("B")]),
                  _c("td", { attrs: { rowspan: "5" } }, [
                    _c("p", [
                      _vm._v(
                        "vehicule de transport marfa cu MTMA mai mica sau egala de 3.5 tone"
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        "goods transport vehicle with maximum total weight authorized less or equal to 3.5 t"
                      ),
                    ]),
                  ]),
                  _c("td", [_vm._v("-")]),
                  _c("td", [_vm._v("-")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("7 zile / days")]),
                  _c("td", [_vm._v("6")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("30 zile / days")]),
                  _c("td", [_vm._v("16")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("90 zile / days")]),
                  _c("td", [_vm._v("36")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("12 luni / months")]),
                  _c("td", [_vm._v("96")]),
                ]),
                _c("tr", [
                  _c("td", { attrs: { rowspan: "5" } }, [_vm._v("C")]),
                  _c("td", { attrs: { rowspan: "5" } }, [
                    _c("p", [
                      _vm._v(
                        "vehicule de transport marfa cu MTMA mai mare de 3.5 tone si mai mica sau egala de 7.5 tone"
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        "goods transport vehicle with maximum total weight authorized more than 3.5 t and less or equal to 7.5t"
                      ),
                    ]),
                  ]),
                  _c("td", [_vm._v("1 zi / day")]),
                  _c("td", [_vm._v("4")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("7 zile / days")]),
                  _c("td", [_vm._v("16")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("30 zile / days")]),
                  _c("td", [_vm._v("32")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("90 zile / days")]),
                  _c("td", [_vm._v("92")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("12 luni / months")]),
                  _c("td", [_vm._v("320")]),
                ]),
                _c("tr", [
                  _c("td", { attrs: { rowspan: "5" } }, [_vm._v("D")]),
                  _c("td", { attrs: { rowspan: "5" } }, [
                    _c("p", [
                      _vm._v(
                        "vehicule de transport marfa cu MTMA mai mare de 7.5 tone si mai mica de 12 tone"
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        "goods transport vehicle with maximum total weight authorized more than 7,5 t and less than 12t"
                      ),
                    ]),
                  ]),
                  _c("td", [_vm._v("1 zi / day")]),
                  _c("td", [_vm._v("7")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("7 zile / days")]),
                  _c("td", [_vm._v("28")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("30 zile / days")]),
                  _c("td", [_vm._v("56")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("90 zile / days")]),
                  _c("td", [_vm._v("160")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("12 luni / months")]),
                  _c("td", [_vm._v("560")]),
                ]),
                _c("tr", [
                  _c("td", { attrs: { rowspan: "5" } }, [_vm._v("E")]),
                  _c("td", { attrs: { rowspan: "5" } }, [
                    _c("p", [
                      _vm._v(
                        "vehicule de transport marfa cu MTMA mai mare sau egala de 12 tone, cu maximum 3 axe (inclusiv)"
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        "goods transport vehicle with maximum total weight authorized more or equal to 12 t, maximum 3 axles (including)"
                      ),
                    ]),
                  ]),
                  _c("td", [_vm._v("1 zi / day")]),
                  _c("td", [_vm._v("9")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("7 zile / days")]),
                  _c("td", [_vm._v("36")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("30 zile / days")]),
                  _c("td", [_vm._v("72")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("90 zile / days")]),
                  _c("td", [_vm._v("206")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("12 luni / months")]),
                  _c("td", [_vm._v("720")]),
                ]),
                _c("tr", [
                  _c("td", { attrs: { rowspan: "5" } }, [_vm._v("F")]),
                  _c("td", { attrs: { rowspan: "5" } }, [
                    _c("p", [
                      _vm._v(
                        "vehicule de transport marfa cu MTMA mai mare sau egala de 12 tone, cu minimum 4 axe (inclusiv)"
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        "goods transport vehicle with total maximum authorized weight more or equal to 12 t, minimum 4 axles (including)"
                      ),
                    ]),
                  ]),
                  _c("td", [_vm._v("1 zi / day")]),
                  _c("td", [_vm._v("11")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("7 zile / days")]),
                  _c("td", [_vm._v("55")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("30 zile / days")]),
                  _c("td", [_vm._v("121")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("90 zile / days")]),
                  _c("td", [_vm._v("345")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("12 luni / months")]),
                  _c("td", [_vm._v("1210")]),
                ]),
                _c("tr", [
                  _c("td", { attrs: { rowspan: "5" } }, [_vm._v("G")]),
                  _c("td", { attrs: { rowspan: "5" } }, [
                    _c("p", [
                      _vm._v(
                        "vehicule de transport persoane cu mai mult de 9 locuri pe scaune (inclusiv conducatorul auto) si maximum 23 locuri pe scaune (inclusiv conducatorul auto)"
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        "passenger transport vehicles with more than 9 seats (including the driver) and maximum 23 seats (including the driver)"
                      ),
                    ]),
                  ]),
                  _c("td", [_vm._v("1 zi / day")]),
                  _c("td", [_vm._v("4")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("7 zile / days")]),
                  _c("td", [_vm._v("20")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("30 zile / days")]),
                  _c("td", [_vm._v("52")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("90 zile / days")]),
                  _c("td", [_vm._v("120")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("12 luni / months")]),
                  _c("td", [_vm._v("320")]),
                ]),
                _c("tr", [
                  _c("td", { attrs: { rowspan: "5" } }, [_vm._v("H")]),
                  _c("td", { attrs: { rowspan: "5" } }, [
                    _c("p", [
                      _vm._v(
                        "vehicule de transport persoane cu mai mult de 23 locuri pe scaune (inclusiv conducatorul auto)"
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        "passenger transport vehicles with more than 23 seats (including the driver)"
                      ),
                    ]),
                  ]),
                  _c("td", [_vm._v("1 zi / day")]),
                  _c("td", [_vm._v("7")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("7 zile / days")]),
                  _c("td", [_vm._v("35")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("30 zile / days")]),
                  _c("td", [_vm._v("91")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("90 zile / days")]),
                  _c("td", [_vm._v("210")]),
                ]),
                _c("tr", [
                  _c("td", [_vm._v("12 luni / months")]),
                  _c("td", [_vm._v("560")]),
                ]),
              ]
            ),
          ]),
          _c("p", [
            _vm._v(
              "Pentru autoturismele si pentru vehiculele de transport marfa cu masa totala maxima autorizata mai mica sau egala cu 3,5 tone, durata minima pentru care se poate achita tariful de utilizare este de 7 zile."
            ),
          ]),
          _c("p", [
            _vm._v(
              "Responsabilitatea achitarii tarifului de utilizare si a detinerii rovinietei valabile, precum si a achitarii tarifului de trecere sau a tarifului de concesiune revine in exclusivitate utilizatorilor romani, iar in cazul utilizatorilor straini, acesta revine in exclusivitate conducatorului auto a vehiculului."
            ),
          ]),
          _c("p", [
            _vm._v(
              "Fapta de a circula fara a detine rovinieta valabila constituie contraventie si se sanctioneaza cu amenda."
            ),
          ]),
          _c("p", [
            _vm._v(
              "Contravenientul are obligatia de a achita, pe langa amenda contraventionala, cu titlu de tarif de despagubire, in functie de tipul vehiculului folosit fara a detine rovinieta valabila, sumele stabilite potrivit anexei a a OUG 15/2002 cu modificarile si completarile ulterioare."
            ),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }